import t from "./index944.js";
import o from "./index820.js";
var a = t(o, "Set");
export {
  a as default
};
